function initSlide(slider, navSlider){
    let currentSlide;
    let slidesCount;
    let sliderCounter = slider.closest('.slider-main').find('.counter');

    let updateSliderCounter = function(slick, currentIndex) {
        currentSlide = slick.slickCurrentSlide() + 1;
        slidesCount = slick.slideCount;
        sliderCounter.text(currentSlide + ' / ' +slidesCount)
    };

    slider.on('init', function(event, slick) {
        updateSliderCounter(slick);
    });

    slider.on('afterChange', function(event, slick, currentSlide) {
        updateSliderCounter(slick, currentSlide);
    });

    slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: navSlider
    });

    navSlider.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: slider,
        dots: false,
        arrows: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1050,
                settings: {
                    arrows: false
                }
            },
            {
                breakpoint: 868,
                settings: {
                    slidesToShow: 4,
                    arrows: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    arrows: false
                }
            }
        ]
    });
}


$(document).ready(function(){
    let firstSlider = $('.js_tab-item .quality-answer__item-content').eq(0).find('.js_slider-main');
    let firstNav = $('.js_tab-item .quality-answer__item-content').eq(0).find('.js_slider-nav');
    if(firstSlider.length){
        initSlide(firstSlider, firstNav)
    }

    $('.js_quality-answer').find('.js_tab-item .quality-answer__item-content')/*.not(":eq(0)")*/.slideUp();
    // $('.js_quality-answer').find('.js_tab-item').eq(0).addClass('opened')

    let currentVideoSlide;
    let slidesVideoCount;
    let sliderVideoCounter = $('.js_video-counter');

    let updateVideoSliderCounter = function(slick, currentIndex) {
        currentVideoSlide = slick.slickCurrentSlide() + 1;
        slidesVideoCount = slick.slideCount;
        sliderVideoCounter.text(currentVideoSlide + ' / ' +slidesVideoCount)
    };

    $(".js-video__slider").on('init', function(event, slick) {
        updateVideoSliderCounter(slick);
    });

    $(".js-video__slider").on('afterChange', function(event, slick, currentSlide) {
        updateVideoSliderCounter(slick, currentSlide);
    });


    $(".js-video__slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true
    });
    if($('.js_slider-main').length){
        $('.js_slider-main').each(function(){
            let slideQuantity = $(this).find('.slider-main__img').length;
            if(slideQuantity == 1) {
                $(this).closest('.quality-answer__slider').addClass('one-img')
            }
        })

    }

});

$(document).on('click', '.js_video-btn', function(){
    $(this).closest('.video-wrap').addClass('active');
    $(this).closest('.video-wrap').find('video').get(0).play();
})

$('.js_tab-item').on('click', '.js_tab-title', function(){
    $(this).closest('.js_tab-item').toggleClass('opened');
    let mainSlider = $(this).closest('.js_tab-item').find('.js_slider-main');

    if(mainSlider.length){
        if(!mainSlider.hasClass('slick-initialized')){
            let navSlider = mainSlider.closest('.quality-answer__item-content').find('.js_slider-nav');
            initSlide(mainSlider, navSlider)
        }
    }


    $(this).closest('.js_tab-item').find('.quality-answer__item-content').slideToggle();

})


$(document).on('click', '.js_open-modal', function(e){
    e.preventDefault();
    let modal = $(this).attr('href');
    if(modal == '#js_quality-video-modal'){
        let src = $(this).attr('data-src');
        $(modal).find('iframe').attr('src', src);
    } else if (modal == '#js_quality-img-modal') {
        let src = $(this).closest('.slider-main').find('.js_slider-main .slick-current .slider-main__img').attr('data-src');
        $(modal).find('img').attr('src', src);
    }
    $(modal).addClass('opened');
    $('html').css('overflow', 'hidden');
});

$('.js_close-modal').on('click', function(e){
    e.preventDefault();
    $(this).closest('.js_quality-modal').removeClass('opened');
    $('html').css('overflow', '');
});

$(document).on('click tap', function(e){
    let container = $('.quality-modal__inner');
    let btnOpen = $('.js_open-modal');
    if (!container.is(e.target) && container.has(e.target).length === 0 && !btnOpen.is(e.target) && btnOpen.has(e.target).length === 0){
        $('.js_quality-modal').removeClass('opened');
        $('html').css('overflow', '');
    }
});

$(document).scroll(function() {
    let $btnGoTop = $('.js-fixed-btn'),
        windowH = $(window).outerHeight(),
        scrollTop = $(document).scrollTop();

    if ( scrollTop >= windowH ) {
        $btnGoTop.show()
    } else {
        $btnGoTop.hide();
    }
});

$('.js-go-top').on('click', function(e) {
    e.preventDefault();
    $('html,body').animate({ scrollTop: 0 }, 300);
});